<template>
  <main id="app">
    <header class="hero">
      <h1 class="title">20R CS2 Server</h1>
      <p class="subtitle">Chaotic fun.</p>
    </header>

    <section class="cta">
      <a class="connect-btn" href="steam://connect/109.61.80.163:25671/20R" aria-label="Connect to 20R CS2 server via Steam">
        Connect now
      </a>
      <p class="hint">Your Steam client will open and connect to the server.</p>
    </section>

    <section class="features">
      <ul>
        <li>Bullet Point 1</li>
        <li>Bullet Point 2</li>
        <li>Bullet Point 3</li>
      </ul>
    </section>

    <footer class="footer">
      <p>
        Having trouble connecting? Join via console:
        <code>connect 109.61.80.163:25671; password 20R</code>
      </p>
    </footer>
  </main>
</template>

<style scoped>
#app {
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto auto;
  gap: 24px;
  align-items: start;
  justify-items: center;
  padding: 48px 16px;
  box-sizing: border-box;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #e8eaf0;
  background: radial-gradient(1200px 600px at 50% -10%, #223 0%, #111 60%, #0b0b0b 100%);
}

.hero { text-align: center; }
.title {
  margin: 0 0 8px;
  font-size: clamp(22px, 5vw, 40px);
  font-weight: 800;
  letter-spacing: 0.2px;
}
.subtitle {
  margin: 0;
  opacity: 0.85;
}

.cta { text-align: center; }
.connect-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 28px;
  border-radius: 10px;
  background: linear-gradient(180deg, #00ffa3 0%, #00cc88 100%);
  color: #082016;
  text-decoration: none;
  font-weight: 800;
  letter-spacing: 0.3px;
  font-size: 18px;
  box-shadow: 0 10px 24px rgba(0, 255, 163, 0.25), inset 0 1px 0 rgba(255,255,255,0.25);
  transition: transform 0.08s ease, filter 0.2s ease, box-shadow 0.2s ease;
}
.connect-btn:hover { transform: translateY(-1px); filter: brightness(1.05); }
.connect-btn:active { transform: translateY(0); filter: brightness(0.98); }
.hint { margin-top: 10px; opacity: 0.7; font-size: 14px; }

.features ul {
  margin: 0; padding: 0; list-style: none;
  display: grid; gap: 8px; text-align: left;
}
.features li::before {
  content: "•"; color: #00ffa3; margin-right: 8px; font-weight: 900;
}

.footer { text-align: center; opacity: 0.8; font-size: 13px; }
.footer code { background: #1a1f24; padding: 2px 6px; border-radius: 6px; }
</style>

